import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names with clsx and then de-duplicates conflicting
 * Tailwind utilities via tailwind-merge. Standard shadcn helper used
 * by every component under src/components/ui/.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
